import { type FactoryProvider, inject } from '@angular/core';

import { type TuiDay, TuiDayOfWeek } from '@taiga-ui/cdk';
import { tuiCalendarOptionsProvider } from '@taiga-ui/core';

import { FinEnvironmentService } from '@finverity/platform-app/core/services';

const SATURDAY_SUNDAY_WEEKEND: ReadonlySet<number> = new Set([TuiDayOfWeek.Saturday, TuiDayOfWeek.Sunday]);
const FRIDAY_SATURDAY_WEEKEND: ReadonlySet<number> = new Set([TuiDayOfWeek.Friday, TuiDayOfWeek.Saturday]);

/**
 * Marks the deployment's weekend on every Taiga calendar: Friday and Saturday when the environment sets
 * `isFridaySaturdayWeekend`, Saturday and Sunday otherwise. The first day of the week keeps Taiga's default.
 */
export const CALENDAR_WEEKEND_PROVIDER: FactoryProvider = tuiCalendarOptionsProvider(() => {
  const weekendDays = inject(FinEnvironmentService).platform.isFridaySaturdayWeekend
    ? FRIDAY_SATURDAY_WEEKEND
    : SATURDAY_SUNDAY_WEEKEND;

  return {
    dayType: (day: TuiDay): string => (weekendDays.has(day.dayOfWeek(false)) ? 'weekend' : 'weekday'),
  };
});
